export const USER_ES = {
  SUCCESS_VALUE: 'Exitoso',
  FAIL_VALUE: 'Fallido',
  EARN_VALUE: 'Obtenido',
  PENDING_VALUE: 'Pendiente',
  REDEEM_VALUE: 'Canjeado',
  UPDATE_USER_INFO: 'Actualizar informacion de usuario',
  LOGIN_TITTLE: 'Ingrese su credenciales',
  LOGIN: 'Log in',
  USER: 'Usuario',
  PASSWORD: 'Contraseña',
  GETIN: 'Ingresar',
  BLOCK_USER_VALUE: 'Block user',
  BAN_USER_VALUE: 'Ban user',
  UPDATE_USER: 'Actualizar Usuario',
  USER_NAME: 'Nombre',
  USER_EMAIL: 'Email',
  USER_PHONE: "Celular",
  USER_AVAILABLE_POINTS: "Puntos disponibles",
  MERGE_USER_MESSAGE: "Seleccione la cuenta a la que desee integrar los datos",
  MERGE_USER_DESCRIPTION: "La información de la cuenta origen será transferida a la cuenta destino, esto incluye Nombre, Número celular, Email y los Puntos acumulados.",
  // Transaction Catalogs

  TRANSACTION_tapresearch_survey: 'Puntos por contestar encuesta',
  TRANSACTION_inbrain_survey: 'Puntos por contestar encuesta',
  TRANSACTION_inbrain_survey_disqualified: 'Puntos por contestar encuesta',
  TRANSACTION_pollfish_survey: 'Puntos por contestar encuesta',
  TRANSACTION_peanut_survey: 'Puntos por contestar encuesta',
  TRANSACTION_tapjoy_offer: 'Remuneración por oferta',
  TRANSACTION_revu_offerwall: 'Remuneración por oferta premium',
  TRANSACTION_fyber_offerwall: 'Remuneración por oferta',
  TRANSACTION_peanut_offer: 'Remuneración por oferta',
  TRANSACTION_name_incentive: 'Actualización de perfil: Nombre',
  TRANSACTION_phone_incentive: 'Actualización de perfil: Celular',
  TRANSACTION_gender_incentive: 'Actualización de perfil: Genero',
  TRANSACTION_location_incentive: 'Actualización de perfil: Ubicación',
  TRANSACTION_email_incentive: 'Actualización de perfil: Email',
  TRANSACTION_search_incentive: 'Actualización de perfil: Búsqueda',
  TRANSACTION_leader_incentive: 'Líder del mes',
  TRANSACTION_game_payout: 'Puntos por tiempo de juego',
  TRANSACTION_read_news: 'Puntos por lectura de noticias',
  TRANSACTION_fluent_rewards: 'Finalización de la oferta Hot Deal',
  TRANSACTION_onboarding: 'Puntos de incorporación',
  TRANSACTION_share_ad: 'Primer anuncio compartido',
  TRANSACTION_save_ad: 'Primer anuncio guardado',
  TRANSACTION_usage: 'Puntos de uso diario',
  TRANSACTION_feedback: 'Primera retroalimentación',
  TRANSACTION_referral: 'Puntos de bonificación: Referido',
  TRANSACTION_referent: 'Puntos de bonificación: Referente',
  TRANSACTION_app_recommend_bonus: 'Puntos por descarga de apps',
  TRANSACTION_home_widget: 'Puntos del widget de noticias',
  TRANSACTION_rv_no_video: 'Puntos por videos no disponibles',
  TRANSACTION_app_recommend_incentive: 'Puntos por descarga de apps',
  TRANSACTION_bonus_ads: 'Anuncios intermediarios',
  TRANSACTION_rewarded_video: 'Puntos por ver video',
  TRANSACTION_push_reward_campaign: 'Puntos de campaña de recompensa Push',
  TRANSACTION_revu_offer_revoke: 'Oferta Premium revocada',
  TRANSACTION_offerwall_fulfillment: 'Callback de cumplimiento de oferta',
  TRANSACTION_charging_screen: 'Conceder puntos de clasificación',
  TRANSACTION_cash_out: 'Canje de puntos',
  TRANSACTION_inmarket_earning: 'Canje de ofertas locale',
  TRANSACTION_offer_redemption: 'Canje de oferta',
  TRANSACTION_gift_card_refund: 'Devolución de puntos',
  TRANSACTION_expiration: 'Puntos expirados',
  TRANSACTION_deleted_account: 'Cuenta borrada',
  TRANSACTION_account_transfer: 'Transferencia de cuenta',
  TRANSACTION_other: 'Otro'
}
